module.exports = __webpack_public_path__ + "static/cardbg-5dcb8ff59d3a2f593e942caa52ae5f8e.png";